import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToServices = () => {
    const element = document.getElementById('servicios');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="hero">
      <div className="hero-background">
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title fade-in-up">
              Bienvenidos a tu plan
              <span className="logo-style-text">
                <span className="multi-text">Multi</span><span className="servicios-text">servicios</span>
                <span className="underline"></span>
              </span>
            </h1>
            <p className="hero-subtitle fade-in-up">
              Una asistencia para cada ocasión de tu vida
            </p>
            <p className="hero-description fade-in-up">
              Ofrecemos soluciones integrales de asistencia para que puedas vivir con tranquilidad.
              Desde el hogar hasta la tecnología, estamos aquí para ayudarte en cada momento.
            </p>
            <div className="hero-actions fade-in-up">
              <button className="btn btn-primary btn-large" onClick={scrollToServices}>
                Conoce tus asistencias
              </button>
              <a href='https://galicia.dspigs.com/' target="_blank" rel="noopener noreferrer" className="btn-link">
                <button className="btn btn-secondary btn-large">
                  Agenda tu asistencia
                </button>
              </a>
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-card">
              <div className="card-header">
                <div className="card-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="card-content">
                <div className="service-item">
                  <div className="service-icon">
                    <img src={"/images/hogar.png"} alt="Asistencia al Hogar" />
                  </div>
                  <div className="service-info">
                    <h4>Asistencia al Hogar</h4>
                    <p>Disponible 24/7</p>
                  </div>
                  <div className="service-status active">●</div>
                </div>
                <div className="service-item">
                  <div className="service-icon">
                    <img src={"/images/mascotas.png"} alt="Asistencia Mascotas" />
                  </div>
                  <div className="service-info">
                    <h4>Asistencia Mascotas</h4>
                    <p>Cuidado especializado</p>
                  </div>
                  <div className="service-status active">●</div>
                </div>
                <div className="service-item">
                  <div className="service-icon">
                    <img src={"/images/salud.png"} alt="Asistencia Salud" />
                  </div>
                  <div className="service-info">
                    <h4>Asistencia Salud</h4>
                    <p>Profesionales certificados</p>
                  </div>
                  <div className="service-status active">●</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;